import CSVPreviewEmptySection from '../CSVPreviewEmptySection'
import CSVParametersBuilder from '../CSVParametersBuilder'
import CSVParametersSection from '../CSVParametersSection'
import TTDetailCSVPreviewColumnsStrategy from './TTDetailCSVPreviewColumnsStrategy'
import TTDetailCSVPreviewHeader from './TTDetailCSVPreviewHeader'
import TTDetailCSVPreviewGroupingSection from './TTDetailCSVPreviewGroupingSection'
import TTDetailCSVPreviewTotalSection from './TTDetailCSVPreviewTotalSection'

export default function TTDetailCSVPreviewGenerator() {}

TTDetailCSVPreviewGenerator.prototype.init = function(){
  return this;
};

TTDetailCSVPreviewGenerator.prototype.generatePreviewTable = function( reportParameters, reportParamsStringBuilder ){

    // if there is collision clear third level
    const groupingLevels = TTDetailPreviewUtils.filterGroupingLevelsIfExistCollision(
        [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel],
        reportParameters.joinCommentsByTask
    );

    const notEmptyGroupingLevels = ReportPreviewUtils.filterNotEmptyLevels(groupingLevels)

    const needSwitchToMe = reportParameters.needSwitchToMe

    const columnStrategy = new TTDetailCSVPreviewColumnsStrategy().init(notEmptyGroupingLevels, reportParameters.joinCommentsByTask, needSwitchToMe)

    const headerSection = new TTDetailCSVPreviewHeader().init(columnStrategy)

    const groupingSection = new TTDetailCSVPreviewGroupingSection().init(notEmptyGroupingLevels.length, columnStrategy)
    const totalSection = new TTDetailCSVPreviewTotalSection().init(columnStrategy);

    const table = document.createElement( "table" );
    table.className = "reportCsvPreviewTable ttdetail";
    const tBody = document.createElement( "tbody" );
    table.appendChild( tBody );

    const totalColumnsNum = notEmptyGroupingLevels.length + columnStrategy.getNumberOfDetailsCells() + 1 + 1; // + total column + comments
    ReportPreviewUtils.addSheetHeaderRow( tBody, totalColumnsNum );

    const paramsBuilder = new CSVParametersBuilder().init();
    paramsBuilder.addDateRangeParam( reportParameters.dateRangeSelection, reportParamsStringBuilder );
    paramsBuilder.addCPParam( reportParameters.customersProjectsSelection, reportParamsStringBuilder );
    paramsBuilder.addUsersParam( reportParameters.userSelection, reportParamsStringBuilder );
    if ( EnabledFeatures.TTA )
        paramsBuilder.addTimeTrackStatusParam( reportParameters.timeApprovalStatus );

    const parametersSection = new CSVParametersSection().init( paramsBuilder, totalColumnsNum );

    parametersSection.addRows( tBody );
    new CSVPreviewEmptySection().init(1, totalColumnsNum).addRows(tBody);
    headerSection.addRows(tBody);
    groupingSection.addRows( tBody );
    new CSVPreviewEmptySection().init(1, totalColumnsNum).addRows(tBody);
    totalSection.addRows(tBody);

    return table;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/ttdetail/TTDetailCSVPreviewGenerator.js